export enum SearchCategory {
  /** all */
  All = 'ALL',
  /** development */
  Development = 'DEVELOPMENT',
  /** plot */
  Plot = 'PLOT',
  /** rental */
  Rental = 'RENTAL',
  /** resale */
  Resale = 'RESALE',
}

export enum TypeOfSearch {
  Residential = 'RESIDENTIAL',
  Commercial = 'COMMERCIAL',
  Development = 'DEVELOPMENT',
}
